import { EdgeButton } from './EdgeButton/EdgeButton';

export const edgeTypes = {
  edgebutton: EdgeButton,
};

export enum EdgeTypes {
  EDGEBUTTON = 'edgebutton',
}
